export default "__VITE_ASSET__C9ELQJ59__"